module.exports = __webpack_public_path__ + "img/footer.268e814b.png";